export const CLIENT_LIST = 'CLIENT_LIST';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';

export default { CLIENT_LIST, UPDATE_CLIENT };
